import * as React from 'react';
import { useState } from 'react';
import Paper from '@mui/material/Paper';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import styled from 'styled-components';

const ListItem = styled('li')(() => ({
  margin: '3px',
}));

interface Props {
  valuesList: string[];
  setValuesList: (values: string[]) => void;
}

export const AddSpinradValues: React.FC<Props> = ({
  valuesList,
  setValuesList,
}) => {
  const [currentValue, setCurrentValue] = useState<string>('');
  const [error, setError] = useState<string>('');

  const handleAddValue = (): void => {
    const trimmed = currentValue.trim();

    if (!trimmed) {
      setError('required');
      return;
    }

    if (valuesList.some(v => v.toLowerCase() === trimmed.toLowerCase())) {
      setError('this value was already added');
      return;
    }

    setValuesList([...valuesList, trimmed]);
    setCurrentValue('');
    setError('');
  };

  const handleRemoveValue = (value: string): void => {
    setValuesList(valuesList.filter(v => v !== value));
  };

  return (
    <Paper
      elevation={3}
      sx={{
        width: '100%',
        alignSelf: 'center',
        height: 'auto',
        paddingBottom: '10px',
        marginBottom: '1rem',
        marginTop: '0.2rem',
        backgroundColor: 'rgb(194, 194, 194) !important',
        color: '#000',
      }}
    >
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div style={{ width: '94%', alignSelf: 'center' }}>
          <h3
            style={{
              margin: 'unset',
              marginTop: '12px',
              marginBottom: '5px',
              paddingLeft: '3px',
            }}
          >
            Kernwerte
          </h3>

          <div
            style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}
          >
            <TextField
              margin="dense"
              id="spinradValue"
              name="spinradValue"
              value={currentValue}
              onChange={event => {
                setCurrentValue(event.target.value);
                if (event.target.value?.trim()) setError('');
              }}
              onKeyDown={event => {
                if (event.key === 'Enter') {
                  event.preventDefault();
                  handleAddValue();
                }
              }}
              label="Value"
              type="text"
              variant="outlined"
              error={!!error}
              helperText={error}
              fullWidth
              inputProps={{ maxLength: 50 }}
            />
            <Button
              onClick={handleAddValue}
              variant="contained"
              style={{ marginTop: '8px' }}
            >
              Add
            </Button>
          </div>
        </div>

        {valuesList?.length > 0 && (
          <div
            style={{
              width: '94%',
              alignSelf: 'center',
              paddingTop: '15px',
            }}
          >
            <Paper
              sx={{
                background: '#fff !important',
                display: 'flex',
                justifyContent: 'start',
                flexWrap: 'wrap',
                listStyle: 'none',
                width: '100%',
                p: 0.5,
                m: 0.5,
              }}
              elevation={4}
            >
              {valuesList.map((value: string, index: number) => (
                <ListItem key={index}>
                  <Chip
                    label={value}
                    size="small"
                    onDelete={() => handleRemoveValue(value)}
                    sx={{
                      color: '#000',
                      '& .MuiChip-deleteIcon': {
                        color: 'rgba(0, 0, 0, 0.55)',
                      },
                    }}
                  />
                </ListItem>
              ))}
            </Paper>
          </div>
        )}
      </Box>
    </Paper>
  );
};
